import { CATEGORIES } from '@app/src/config/categories';

export const getProducts = () => {
  let arr = [];
  arr.push(CATEGORIES['inmueble']);
  arr.push(CATEGORIES['vehiculo']);
  arr.push(CATEGORIES['empleo']);
  arr.push(CATEGORIES['educacion']);
  arr.push(CATEGORIES['oportunidad']);
  return arr;
}

const getItemProduct = (alias: string) =>
  getProducts().filter((item) => item.alias === alias);

export const getImageByAlias = (alias: string) => {
  const product = getItemProduct(alias);
  return product && product[0] && product[0]['bgImage'];
};

export const getColorRgbByAlias = (alias: string) => {
  const product = getItemProduct(alias);
  return product && product[0] && product[0]['colorRgba'];
};

export const navConfig = getProducts().map((item) => ({
  alias: item.alias,
  text: item.name,
  icon: item.icon,
  color: item.color,
  linkFb: item.linkFb
}));

export const getItemNav = (alias: string) =>
  navConfig.filter((item) => item.alias === alias);
